import React, { useState, useEffect } from "react";

export const PackageSelector = ({ trip, getTrip, linkedTrips }) => {
  const [selectedTrip, setSelectedTrip] = useState(trip);
  const [previousTrip, setPreviousTrip] = useState(trip);

  const handleChange = async (event) => {
    const selectedTripId = event.target.value;
    const selectedTrip = linkedTrips.find((t) => t.id === selectedTripId);
    setSelectedTrip(selectedTrip);

    if (selectedTrip.id !== previousTrip.id) {
        const success = await getTrip(selectedTrip.id, true);
        if (!success) {
          setSelectedTrip(previousTrip);
          alert('This package is sold out.');
        } else {
          setPreviousTrip(selectedTrip);
        }
      }
  };

  return (
    <>
      {linkedTrips.length > 1 ? (
        <>
          <h4 style={{ marginTop: 8 }}>Package</h4>
          <select className="w-full p-2 border rounded" value={selectedTrip.id} onChange={handleChange} style={{ fontWeight: 'bold', marginLeft: -4 }}>
            {linkedTrips.map((linkedTrip) => (
              <option key={linkedTrip.id} value={linkedTrip.id}>
                {linkedTrip.name} {linkedTrip.description ? `- ${linkedTrip.description}` : ''}
              </option>
            ))}
          </select>
        </>
      ) : (
        <></>
      )}
    </>
  );
};
